$(function() {
  $('.c-modal__content__back-button').on('click', function() {
    $('.c-modal').fadeOut()
  })
})